import dayjs from 'dayjs';
import { subDays, subHours, subMinutes } from 'date-fns';
import { TimeOptionType } from 'src/features/trends/types';

export const getTimestampsBasedOnTimeBox = (selectedBox: TimeOptionType) => {
  const now = new Date();

  if (selectedBox.endsWith('m')) {
    const minutes = Number(selectedBox.slice(0, -1));
    return { fromDate: dayjs(subMinutes(now, minutes)), toDate: dayjs(now) };
  }

  if (selectedBox.endsWith('h')) {
    const hours = Number(selectedBox.slice(0, -1));
    return { fromDate: dayjs(subHours(now, hours)), toDate: dayjs(now) };
  }

  const days = Number(selectedBox.slice(0, -1));
  return {
    fromDate: dayjs(subDays(now, days)),
    toDate: dayjs(now),
  };
};
